import { message } from 'antd';
import { ConfigOptions } from 'antd/es/message';
import 'antd/es/message/style/index.css';
import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import './index.less';

const { error, warning, warn, info, success, loading, config, destroy, open } = message;

const ErrorIcon = (
    <IconFont
        fontSize={16}
        color="var(--content-system-info-icon-warning)"
        name="ExclamationMarkCircleBoldFill"
        style={{
            marginRight: 8,
        }}
    />
);

const InfoIcon = (
    <IconFont
        fontSize={16}
        color="var(--content-system-info-icon-regular)"
        name="InfoCircleBoldFill"
        style={{
            marginRight: 8,
        }}
    />
);

const SuccessIcon = (
    <IconFont
        fontSize={16}
        color="var(--content-system-info-icon-success)"
        name="CheckCircleFillBold"
        style={{
            marginRight: 8,
        }}
    />
);

interface MessageConfigOptions extends ConfigOptions {
    content?: React.ReactNode;
}

const Message = {
    error(config: MessageConfigOptions | string) {
        if (typeof config === 'string') {
            return error({
                content: config,
                icon: ErrorIcon,
            });
        }
        return error({
            ...config,
            icon: ErrorIcon,
        });
    },
    info(config: MessageConfigOptions | string) {
        if (typeof config === 'string') {
            return info({
                content: config,
                icon: InfoIcon,
            });
        }
        return info({
            ...config,
            icon: InfoIcon,
        });
    },
    warning,
    warn,
    success(config: MessageConfigOptions | string) {
        if (typeof config === 'string') {
            return success({
                content: config,
                icon: SuccessIcon,
            });
        }
        return success({
            ...config,
            icon: SuccessIcon,
        });
    },
    loading,
    config,
    destroy,
    open,
};

Message.config({
    maxCount: 1,
});

export default Message;
